function cov_1yfpzw7w6p() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/helpers/inputSizing.ts";
  var hash = "96e92dece1e0a3d1c393dd694eb9c6cc51c0c571";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/helpers/inputSizing.ts",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 29
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 27,
          column: 38
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "2": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 78
        }
      },
      "3": {
        start: {
          line: 31,
          column: 35
        },
        end: {
          line: 31,
          column: 78
        }
      },
      "4": {
        start: {
          line: 33,
          column: 35
        },
        end: {
          line: 47,
          column: 11
        }
      },
      "5": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 35
        }
      },
      "6": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 34,
          column: 35
        }
      },
      "7": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 39,
          column: 5
        }
      },
      "8": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 38,
          column: 8
        }
      },
      "9": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 46,
          column: 6
        }
      },
      "10": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 49,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 27,
            column: 38
          },
          end: {
            line: 27,
            column: 39
          }
        },
        loc: {
          start: {
            line: 30,
            column: 23
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 30
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 54
          },
          end: {
            line: 33,
            column: 55
          }
        },
        loc: {
          start: {
            line: 33,
            column: 83
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 78
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 35
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 34
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 39,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 39,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 35
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "96e92dece1e0a3d1c393dd694eb9c6cc51c0c571"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1yfpzw7w6p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1yfpzw7w6p();
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import { css } from '@emotion/react';
import { media } from '@opendoor/bricks/theme/novo/foundations/breakpoints';

// Enforcing the len(sizeArray) <= 5

var INDEX_TO_MEDIA_QUERY = (cov_1yfpzw7w6p().s[0]++, {
  1: media.largerThan.XS,
  2: media.largerThan.SM,
  3: media.largerThan.MD,
  4: media.largerThan.LG
});

/*
  Goal is to support passing sizeVariant as an array for responsive sizes
  similar to how we use ChakraUI to pass props like marginTop={[0, 8, 12]}
*/
cov_1yfpzw7w6p().s[1]++;
export var buildResponsiveStyling = function buildResponsiveStyling(sizeToSerializedStyles, sizeVariant) {
  cov_1yfpzw7w6p().f[0]++;
  cov_1yfpzw7w6p().s[2]++;
  if (!Array.isArray(sizeVariant)) {
    cov_1yfpzw7w6p().b[0][0]++;
    cov_1yfpzw7w6p().s[3]++;
    return sizeToSerializedStyles[sizeVariant];
  } else {
    cov_1yfpzw7w6p().b[0][1]++;
  }
  var styles = (cov_1yfpzw7w6p().s[4]++, sizeVariant.reduce(function (stylesAcc, curSize, idx) {
    cov_1yfpzw7w6p().f[1]++;
    cov_1yfpzw7w6p().s[5]++;
    if (!curSize) {
      cov_1yfpzw7w6p().b[1][0]++;
      cov_1yfpzw7w6p().s[6]++;
      return stylesAcc;
    } else {
      cov_1yfpzw7w6p().b[1][1]++;
    }
    cov_1yfpzw7w6p().s[7]++;
    if (idx == 0) {
      cov_1yfpzw7w6p().b[2][0]++;
      cov_1yfpzw7w6p().s[8]++;
      return /*#__PURE__*/css(sizeToSerializedStyles[curSize], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:styles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
    } else {
      cov_1yfpzw7w6p().b[2][1]++;
    }
    cov_1yfpzw7w6p().s[9]++;
    return /*#__PURE__*/css(stylesAcc, " ", INDEX_TO_MEDIA_QUERY[idx], "{", sizeToSerializedStyles[curSize], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:styles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  }, /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
  cov_1yfpzw7w6p().s[10]++;
  return styles;
};
//# sourceMappingURL=inputSizing.mjs.map